import ModelPropertyFilterInterface from "../../../../interfaces/model/ModelPropertyFilterInterface";
import SimpleBar from 'simplebar-react';
import {useState} from "react";

interface PropertyFiltersProps {
    properties: ModelPropertyFilterInterface[];
    selectedProperties: Map<number, string[]> | undefined;
    addProperty: (id: number, value: string) => void;
    removeProperty: (id: number, value: string) => void;
    excludePropertyId?: number[];
    includePropertyId?: number[];
}

export default function PropertyFilters({
    properties,
    selectedProperties,
    addProperty,
    removeProperty,
    excludePropertyId,
    includePropertyId
}: PropertyFiltersProps) {
    const filteredProperties = properties.filter(property => {
        if (includePropertyId && includePropertyId.length > 0) {
            return includePropertyId.includes(property.id);
        }
        if (excludePropertyId && excludePropertyId.length > 0) {
            return !excludePropertyId.includes(property.id);
        }
        return true;
    });

    const [activeFolders, setActiveFolders] = useState<string[]>([])

    const toggleFolder = (name: string) => {
        setActiveFolders(isFolderActive(name) ? [...activeFolders.filter(val => val !== name)] : [...activeFolders, name])
    }

    const isFolderActive = (name: string): boolean => {
        return activeFolders.includes(name)
    }

    const isPropertyActive = (id: number, value: string) => {
        if (!selectedProperties) return false;

        return (selectedProperties.get(id) || []).includes(value)
    }

    return (
        <>
            {filteredProperties.length > 0 && filteredProperties.map(property =>
                <div
                    key={property.id} className="all-filters-block">
                    <div className="all-filters__accord">
                        <p className={"all-filters__title all-filters__link f-exp " + (isFolderActive('prop' + property.id) && 'active')}
                           onClick={() => {
                               toggleFolder('prop' + property.id)
                           }}>{property.name}
                            <i
                                className="ico ico-arrow-bot-b"></i></p>
                        {isFolderActive('prop' + property.id) && <div className="all-filters__col">
                            <div className="">
                                <SimpleBar style={{maxHeight: 230}} autoHide={false}>
                                    <div className="scrollbar-inner">
                                        <ul className="filters__collapse-checkboxes">
                                            {property.values.map(value => <li key={value}>
                                                <div
                                                    className={"form-checkbox " + (isPropertyActive(property.id, value) && "active")}
                                                    onClick={() => isPropertyActive(property.id, value) ? removeProperty(property.id, value) : addProperty(property.id, value)}>
                                                    <label className={"label-dot"}></label>
                                                    <label className="label-text">{value}</label>
                                                </div>
                                            </li>)}
                                        </ul>
                                    </div>
                                </SimpleBar>
                            </div>
                        </div>}
                    </div>
                </div>)}
        </>
    );
}